<template>
<div>
     <div v-if="$store.getters.activatedClub" :key="$store.getters.activatedClub.id" class="panel">
        <div class="top-button-row row columns">
          <div class="panel-title">Filtres</div>
          <div class="large-3 columns">
            compétition
            <select name="" v-if="$store.getters.formatedClubList" v-model="chosenLeague">
              <option v-for="league in $store.getters.leagueListForActivatedClub" v-bind:value="league">{{league.name}}</option>
            </select>
          </div>
          <div class="large-3 columns">
            saison
            <select name="" v-if="chosenLeague" v-model="chosenSeason">
              <option v-for="season in chosenLeague.seasons" v-bind:value="season">{{season.name}}</option>
            </select>
          </div>
          <div class="large-3 columns">
            Journée
            <select name="" v-if="chosenSeason" v-model="chosenWeek">
              <option v-for="week in weekList" v-bind:value="week">{{week.title}}</option>
            </select>
          </div>
          <div class="large-3 columns">
            status
            <select id="" name="" v-model="selectedFilter" >
                <option v-bind:value="0">Tous les matchs</option>
                <option v-bind:value="1">Matchs en cours de saisie</option>
                <option v-bind:value="2">Matchs publiés</option>
            </select>
          </div>
        </div>
    </div>
    <div class="row columns mt-1 mb-1">
          <div class="large-4 columns pl-0 large-centered">
                <router-link :to="{ name: 'mrStep1', params:{'id':'0'}}" >
                <button class=""><span><i class="fa fa-star" aria-hidden="true"></i>&nbsp;Nouveau Rapport de match</span></button></a>
                </router-link>
          </div>
    </div>
    <p v-if="!$store.getters.activatedClub" class="note">nb: cette liste n'affiche que les 20 derniers matchs, cliquez sur une ligue pour une recherche approfondie</p>
    <div class="panel">
        <div v-if="filteredList.length > 0" class="row columns">
            <div class="panel-title big-title">
            </div>
            <div class="panel-content" v-if="filteredList.length > 0">
                <div v-for="mr in filteredList">
                    <mrHeader :unpublish="canUnpublish(mr)"
                              :actions="true"
                              v-if="!mr.is_db_report" class="match-header"
                              @matchDeleted="reloadMatchList"
                              :match="mr"></mrHeader>
                    <mrDBHeader :actions="true"  v-if="mr.is_db_report" class="match-header" :match="mr"></mrDBHeader>
                    <hr>
                </div>
            </div>
        </div>
        <div v-else>
            <spinner></spinner>
        </div>
    </div>
</div>
</template>

<script>
import spinner from '../common/spinner.vue'
import store from '../../store/index.js'
import mrHeader from './mr-header.vue'
import mrDBHeader from './mr-db-header.vue'
import { leagueSelector } from '../common/league-selector.mixin'

export default {
  name: 'mrList',
  components: {
    spinner,
    mrHeader,
    mrDBHeader
  },
  mixins: [leagueSelector],
  props: {
    'id': null
  },
  data () {
    return {
      selectedFilter: 2,
      selectedLeagueValue: null,
      selectedSeasonValue: null,
      selectedWeekValue: null
    }
  },
  watch: {
    activatedClub: function (newVal, oldVal) {
      this.selectedLeagueValue = null
    },
    weekList: function (val) {
      // si la liste des semaines arrivent après que les league et season aient été selectionné,
      // on choisit la dernière journée
      if (this.selectedSeasonValue && this.selectedLeagueValue && !this.selectedWeekValue) {
        this.selectedWeek = this.weekList[this.weekList.length - 1]
      }
    }
  },
  computed: {
    activatedClub: function () {
      return this.$store.getters.activatedClub
    },
    weekList: function () {
      if (this.chosenSeason) {
        return store.getters.weekListForLeague(this.chosenSeason.id)
      }
      return this.$store.getters.weekList
    },
    chosenLeague: {
      get: function () {
        if (this.$store.getters.leagueListForActivatedClub && !this.selectedLeagueValue) {
          this.chosenLeague = this.$store.getters.leagueListForActivatedClub[this.$store.getters.leagueListForActivatedClub.length - 1]
        }
        return this.selectedLeagueValue
      },
      set: function (newChosenLeague) {
        this.selectedLeagueValue = newChosenLeague
        this.chosenSeason = newChosenLeague.seasons[newChosenLeague.seasons.length - 1]
      }
    },
    chosenSeason: {
      get: function () {
        return this.selectedSeasonValue
      },
      set: function (newChosenSeason) {
        this.selectedSeasonValue = newChosenSeason
        let weekList = store.getters.weekListForLeague(newChosenSeason.id)
        if (weekList.length > 0) {
          this.chosenWeek = weekList[weekList.length - 1]
        } else {
          this.chosenWeek = null
        }
      }
    },
    chosenWeek: {
      get: function () {
        return this.selectedWeekValue
      },
      set: function (newSelectedWeek) {
        this.selectedWeekValue = newSelectedWeek
      }
    },
    filteredList: function () {
      let filteredList = this.$store.getters.latestMatchReportList
      if (this.$store.getters.activatedClub && this.chosenWeek && this.chosenSeason) {
        filteredList = this.$store.getters.matchListForLeagueAndWeek(this.chosenSeason.id, this.chosenWeek.id)
        if (this.selectedFilter === 1) {
          filteredList = filteredList.filter(mr => { return mr.status === 0 })
        } else if (this.selectedFilter === 2) {
          filteredList = filteredList.filter(mr => { return mr.status !== 0 })
        }
      }
      return filteredList
    }
  },
  methods: {
    reloadMatchList () {
      console.log('matchsReloaded')
    },
    canUnpublish (mr) {
      // en résumé on peut dépublier un match si c'est le dernier que les deux équipes ont joué.
      // donc si on ne trouve pas de rapport de match publié !!, ayant un id supérieur
      let filtered = this.$store.getters.matchReportList.filter(match => {
        return match.id > mr.id
      })
      let found = filtered.findIndex(match => {
        return match.status === 1 && (match.home_report.team.id === mr.home_report.team.id ||
                match.visitor_report.team.id === mr.home_report.team.id ||
                match.home_report.team.id === mr.visitor_report.team.id ||
                match.visitor_report.team.id === mr.visitor_report.team.id)
      })
      if (found > -1) {
        return false
      } else {
        return true
      }
    }
  },
  created () {
    this.$store.dispatch('showLeaguePanel')
    this.$store.dispatch('deactivateFullSizePage')
    this.$store.dispatch('getMatchReportList')
    this.$store.dispatch('getlatestMatchReportList')
  },
  mounted () {
    this.$store.dispatch('getWeekList')
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.top-button-row {
  margin-top : 1rem;
}
.tip {
  font-size: 0.8rem;
}
.big-title {
    font-size: 1.6rem;
}
    .pl-0 {
    padding-left: 0;
  }
  .mt-1 {
    margin-top: 1rem;
  }
  .note {
    font-size: 0.8rem;
  }
  .mb-1 {
    margin-bottom: 1rem;
  }
</style>



// WEBPACK FOOTER //
// mr-list.vue?7fad38a6